module.exports = __webpack_public_path__ + "static/img/xm@2x.86028417.png";